import { render, staticRenderFns } from "./summaryList.vue?vue&type=template&id=46ab7900&scoped=true"
import script from "./summaryList.vue?vue&type=script&lang=js"
export * from "./summaryList.vue?vue&type=script&lang=js"
import style0 from "./summaryList.vue?vue&type=style&index=0&id=46ab7900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab7900",
  null
  
)

export default component.exports